import React from 'react'
import "./Current_rank_cards.css"

function Current_rank_cards({imgSrc}) {
    return (
        <>
            <section className='Current_rank_cards'>
                <div className="card_circle_holder">
                    <div className="img_holder">
                        <img src={imgSrc} alt="" className='circle_img' />
                    </div>
                </div>

                <div className="content_holder">
                    <div className="text_holder">
                        <h6>Level 1 & 2</h6>
                        <p>Target: 5 | Actual: 30</p>
                    </div>

                    <div className="col-sm-6">
                        <div className="name_holder">
                            <h5>Rising Star</h5>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Current_rank_cards